export default {
    state: {
        authToken: ""
    }
}